
  import React from "react"
  import Component from "/home/pquerna/site/src/layouts/index.js"
  import data from "/home/pquerna/site/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js